/* ==========================================================================
   KINOVA — 21-bosqich: video ostidagi harakatlar paneli

   Bu fayl FAQAT YANGI narsalarni boshqaradi:
     • "Yoqdi" (like) — bir akkaunt uchun bir marta, server tasdiqlaydi;
     • "Ulashish" oynasi (bottom sheet) — ochish/yopish/nusxalash;
     • "Sevimlilar" tugmasi (pleer sahifasidagi nusxasi).

   Baho (yulduzcha) va izohlar mantig'i ATAYLAB bu yerda QAYTA
   YOZILMAGAN — u `film-detail.js` da allaqachon bor va sinovdan
   o'tgan. Panel o'sha JS kutgan identifikatorlarni saqlaydi.
   ========================================================================== */
(function (global) {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function csrf() {
    return global.KINOVA_CSRF_TOKEN
      || (document.querySelector('meta[name="csrf-token"]') || {}).content
      || '';
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': csrf(),
      },
      body: JSON.stringify(body || {}),
    }).then(function (r) {
      return r.json().catch(function () { return {}; })
        .then(function (b) { return { status: r.status, body: b }; });
    });
  }

  var Icon = global.Icon || {};
  function ic(name, size) { return (Icon[name] || Icon.tag || function () { return ''; })(size); }

  /* ══ 1) "YOQDI" ═══════════════════════════════════════════════════ */
  function wireLike(root) {
    var btn = document.getElementById('watchLike');
    if (!btn) return;

    var countEl = document.getElementById('watchLikeCount');
    var url = root.getAttribute('data-like-url') || '';
    var authed = root.getAttribute('data-authed') === '1';
    var loginUrl = root.getAttribute('data-login-url') || '/login';
    var busy = false;

    btn.addEventListener('click', function () {
      /* ⚠️ Mehmonga SOXTA holat ko'rsatilmaydi: tugma "bosilgan"
         ko'rinishga o'tmaydi, balki kirish sahifasiga olib boradi. */
      if (!authed) { global.location.href = loginUrl; return; }
      if (busy || !url) return;
      busy = true;

      post(url).then(function (res) {
        busy = false;
        if (res.status !== 200 || !res.body || res.body.ok !== true) return;

        var liked = res.body.liked === true;
        btn.classList.toggle('is-on', liked);
        btn.setAttribute('aria-pressed', liked ? 'true' : 'false');

        // Raqam SERVERDAN keladi — ekranda taxminiy son turmasin.
        if (countEl && typeof res.body.likes === 'number') {
          countEl.textContent = res.body.likes;
        }

        var svg = btn.querySelector('svg');
        var next = liked ? ic('heartFilled', 18) : ic('heart', 18);
        if (svg && next) svg.outerHTML = next;

        btn.classList.remove('is-pop');
        void btn.offsetWidth; // animatsiyani qayta boshlash
        btn.classList.add('is-pop');
      }).catch(function () { busy = false; });
    });
  }

  /* ══ 2) ULASHISH OYNASI ═══════════════════════════════════════════ */
  function wireShareSheet() {
    var sheet = document.getElementById('shareSheet');
    var bg = document.getElementById('shareSheetBg');
    var openBtn = document.getElementById('watchShare');
    if (!sheet || !bg || !openBtn) return;

    var closeBtn = document.getElementById('shareSheetClose');
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      bg.hidden = false; sheet.hidden = false;
      // Brauzer `hidden` olib tashlanishini ko'rib ulgursin —
      // aks holda ochilish animatsiyasi ishlamaydi.
      requestAnimationFrame(function () {
        bg.classList.add('is-open');
        sheet.classList.add('is-open');
      });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      bg.classList.remove('is-open');
      sheet.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { bg.hidden = true; sheet.hidden = true; }, 300);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKey(e) { if (e.key === 'Escape') close(); }

    openBtn.addEventListener('click', open);
    bg.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    // Havolani bosgach oyna yopilsin (yangi varaqda ochiladi).
    sheet.querySelectorAll('a.sh').forEach(function (a) {
      a.addEventListener('click', function () { setTimeout(close, 150); });
    });

    /* "Nusxalash" — `film-detail.js` dagi `[data-share-copy]` mantig'i
       `.share-row` uchun yozilgan. Bu yerda oynaning O'ZI yopilishi ham
       kerak, shuning uchun alohida tinglovchi. */
    var copy = sheet.querySelector('[data-share-copy]');
    if (copy) {
      copy.addEventListener('click', function () {
        var url = sheet.getAttribute('data-share-url') || global.location.href;
        var done = function () {
          var label = copy.lastChild;
          if (label && label.nodeType === 3) {
            label.nodeValue = 'Nusxalandi';
            setTimeout(function () { label.nodeValue = 'Nusxalash'; }, 1600);
          }
          setTimeout(close, 700);
        };

        if (global.navigator && navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(done);
        } else {
          // Eski brauzerlar uchun zaxira yo'l.
          var ta = document.createElement('textarea');
          ta.value = url; ta.setAttribute('readonly', '');
          ta.style.position = 'fixed'; ta.style.left = '-9999px';
          document.body.appendChild(ta); ta.select();
          try { document.execCommand('copy'); } catch (e) { /* e'tiborsiz */ }
          document.body.removeChild(ta);
          done();
        }
      });
    }
  }

  /* ══ 3) SEVIMLILAR (pleer sahifasidagi nusxasi) ═══════════════════ */
  function wireFav(root) {
    var btn = document.getElementById('watchFav');
    if (!btn) return;

    var authed = root.getAttribute('data-authed') === '1';
    var loginUrl = root.getAttribute('data-login-url') || '/login';
    var id = btn.getAttribute('data-content-id');
    var busy = false;

    btn.addEventListener('click', function () {
      if (!authed) { global.location.href = loginUrl; return; }
      if (busy || !id) return;
      busy = true;

      var on = btn.classList.contains('is-on');
      fetch('/favorites/' + encodeURIComponent(id), {
        method: on ? 'DELETE' : 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-TOKEN': csrf(),
        },
      }).then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (b) {
          busy = false;
          if (!b || b.ok !== true) return;
          var fav = b.is_favorited === true;
          btn.classList.toggle('is-on', fav);
          btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
          var svg = btn.querySelector('svg');
          var next = fav ? ic('check', 17) : ic('plus', 17);
          if (svg && next) svg.outerHTML = next;
        }).catch(function () { busy = false; });
    });
  }

  ready(function () {
    var root = document.getElementById('watchActions');
    if (!root) return;
    wireLike(root);
    wireShareSheet();
    wireFav(root);
  });
})(window);
